import configureStore from "./index";

export const { persistor, store } = configureStore();
